import React from 'react';
import { translate } from 'react-i18next';
import { Image, Button } from 'semantic-ui-react';

import {colors, spacings, shadow, fontSizes, fonts} from 'style';

var style = {
    item: {
        position: 'relative',
        overflow:'hidden',
        border: '1px solid ' + colors.themeDarkGrey,
        borderRadius: '10px',
        padding: spacings.base,
        margin: spacings.small,
        minHeight: '130px',
        lineHeight: '1.5',
    },
    label: {
        position: 'absolute',
        top: '35px',
        left: '100px',
    },
    imageArea: {
        position: 'absolute',
        top: '0px',
        display: 'inline-block',
        width:'60px', 
        height:'100%', 
        lineHeight:'60px', 
    },
    image: {
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-30px',
        height: '60px',
        fontSize: '60px',
        lineHeight: '1',
    },
    textArea: {
        verticalAlign: 'top',
        display: 'block',
        lineHeight: '1.5',
        paddingLeft: '80px',
        paddingRight: '190px',
    },
    title: {
        ...fonts.bodyL,
        color: colors.themeBlue,
    },
    description: {
    },
    buttonArea: {
        position: 'absolute',
        top: '0px',
        right: spacings.small,
        display: 'inline-block',
        width: '170px',
        height: '100%',
        lineHeight: '40px',
    },
    button: {
        fontWeight: 'normal',
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        width: '100%',
        borderRadius: '100px',
        boxShadow: shadow,
        ...fonts.body,
        lineHeight: '1.5',
    },
    connectButton: {
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    disconnectButton: {
        border: '0px solid ' + colors.themeDarkGrey,
        color: 'rgb(216, 84, 84)',
        backgroundColor: '#fff',
    },
};



const PluginItem = ({t, plugin, connect, disconnect, isDeadLink, imageLoadError}) => (
        <div style={style.item}>
            <div style={style.imageArea} className='plugins-imageArea'>
                {Boolean(plugin.logo && plugin.logo.url && !isDeadLink(plugin.logo.url)) ?
                    <Image style={style.image} className='plugins-image' src={plugin.logo.url} alt="" onError={imageLoadError}></Image> 
                    :
                    <i style={style.image} className='icon-circuit-board plugins-image'></i> 
                }
            </div>
            <div style={style.textArea} className='plugins-textArea'>
                <div style={style.title}>
                    {plugin.name}
                </div>
                <div style={style.description}>
                    {plugin.description}
                </div>
            </div>
            <div style={style.buttonArea} className='plugins-buttonArea'>
                {plugin.connected ?
                    <Button style={{...style.button, ...style.disconnectButton}} onClick={()=>(disconnect(plugin))}>
                        {t('Disconnect')}
                    </Button>
                  : <Button style={{...style.button, ...style.connectButton}}    onClick={()=>(connect(plugin))}>
                        {t('Connect')}
                    </Button>
                }
            </div>
        </div>
);

export default translate('plugins')(PluginItem);



// WEBPACK FOOTER //
// ./src/modules/plugins/PluginItem.js